import { useContext } from '@/compat';
import { ref } from 'vue';
import { clone } from 'ramda';

import { DialogTypes } from '@/components/dialogs/constants';
import { clearTypeNameFromObject } from '@/helpers/data/graphql';
import useDialog from './useDialog';
import useConfirm from './useConfirm';
import { isEquals } from '@/helpers/misc';

const usePromisifiedDialog = (defaultValue = null, checkDirty = true, dialogType = DialogTypes.WARNING) => {
  const {
    $lang, $i18n,
  } = useContext();

  const initialLazyValue = ref(defaultValue);
  const lazyValue = ref(defaultValue);
  const lazyResolve = ref(null);
  const dialog = useDialog();

  const edit = newValue => {
    initialLazyValue.value = clone(newValue);
    lazyValue.value = clone(newValue);
    dialog.open();

    return new Promise(resolve => {
      lazyResolve.value = resolve;
    });
  };

  const clear = () => {
    lazyValue.value = clone(defaultValue);
    initialLazyValue.value = clone(defaultValue);
  };

  const close = () => {
    dialog.close();
  };

  const save = () => {
    lazyResolve.value(lazyValue.value);
    clear();
    close();
  };

  const askUserToChangesWillBeLost = useConfirm()[dialogType]();

  const cancel = async () => {
    if (
      (!checkDirty || !isEquals(clearTypeNameFromObject(lazyValue.value), clearTypeNameFromObject(initialLazyValue.value)))
      && !(await askUserToChangesWillBeLost($i18n.t($lang.app.WARNING), $i18n.t($lang.app.YOUR_CHANGES_WILL_BE_LOST_ARE_YOU_SURE)))) {
      return false;
    }

    lazyResolve.value(initialLazyValue.value);
    close();

    return true;
  };

  return {
    lazyValue,
    initialLazyValue,
    dialog,
    edit,
    save,
    close,
    cancel,
    clear,
  };
};

export default usePromisifiedDialog;
